import React from 'react';
import moment from 'moment';
import TWModal from '../ui/tw-modal';

export default function ModalList({
  title,
  headers,
  keys,
  list,
  open,
  size,
  onCloseRequest,
}) {
  const formatKeyValue = (key, value, idx) => {
    switch (key) {
      case 'status':
        return value === 0 ? 'Pending' : value === 10 ? 'Active' : 'Passive';
      case 'createdate':
        return moment.utc(value).local().format('MM/DD/YYYY hh:mm A');
      case 'customerfeeactive':
        return value ? 'Yes' : 'No';
      case 'customerfee':
        return list.customerfeeisrate ? value + '%' : '$' + value;
      case 'address':
        return `${list[idx]?.address || ''} ${
          list[idx]?.apartment && list[idx]?.apartment !== 'null'
            ? list[idx]?.apartment
            : ''
        } ${list[idx]?.city || ''} ${
          list[idx]?.state && list[idx]?.state !== 'null'
            ? list[idx]?.state
            : ''
        }`;
      default:
        return value;
    }
  };

  return (
    <TWModal
      open={open}
      onClose={onCloseRequest}
      title={title}
      size={size === 'lg' ? '4xl' : '2xl'}
      showCloseButton
      bodyClassName="px-4 py-4 sm:px-6 sm:py-5"
    >
      <div className="min-h-[250px] overflow-x-auto">
        <table className="min-w-full divide-y divide-slate-200 dark:divide-slate-600">
          <thead>
            <tr>
              {headers.map((head, headIdx) => (
                <th
                  key={headIdx}
                  scope="col"
                  className="py-3 px-3 text-left text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400"
                >
                  {head}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100 dark:divide-slate-700/60">
            {list.map((element, idx) => (
              <tr key={idx}>
                {keys.map((x, keyIdx) => (
                  <td
                    key={keyIdx}
                    className="whitespace-nowrap px-3 py-3.5 text-sm font-medium text-slate-900 dark:text-slate-100"
                  >
                    {formatKeyValue(x, element[x], idx)}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </TWModal>
  );
}
